// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListA1_comp__kXzpQ"};